
    import { Vue,Component,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import moment from 'moment'
    import icon from '../../assets/expressicon'
    const dashboard = namespace('dashboard')

    @Component
    export default class Home extends Vue{
        get chartData() {
            return{
                columns: ['日期', '派件入库', '派件出库', '寄件入库'],
                rows: this.chartList
            }
        }
        icon:any = icon
		radio2:number =  6
		noticeList = []
		noticeMessage = []
        daterange:any = [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date()]
        @dashboard.State('loading') loading:any
        @dashboard.State('chartList') chartList:any
        @dashboard.State('range') range:any
        @dashboard.State('dashboard') dashboard:any
        @dashboard.Action('getGeneral') getGeneral:any
		@dashboard.Action('getInventory') getInventory:any
		@dashboard.Action('getNotice') getNotice:any
        async mounted(){
            this.getGeneral()
			this.getInventory()
			this.getnoticeList()
		}
		async getnoticeList(){
			const list = await this.getNotice();
			this.noticeList = list.applyMessage;
			this.noticeMessage = list.notice;
		}
        daterangechange(val:any){
            const end = new Date();
            const start = new Date();
            const daterange:any = [start, end]
            if (val == 6) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            }
            if (val == 9) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            }
            if (val == 12) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            }
            this.daterange = daterange
        }
        async search(){
            this.getInventory({
                star: moment(this.daterange[0]).format("YYYY-MM-DD"),
                end: moment(this.daterange[1]).format("YYYY-MM-DD")
            })
        }
        @Watch('daterange')
        onDaterangeChanged(val: any, oldVal: any) {
            console.log(val);
            this.search()
        }
    }
